
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorDeCurso } from '../../controlador-detalles';
    import { Curso } from '@/__env/lib/Cursos';
    import opcion from './cursos-detalles-resumen-preguntas-pregunta-opcion.vue';
    import { Pregunta } from '@/__env/lib/Cursos/Preguntas';
    import { Respuesta } from '@/__env/lib/Cursos/Respuestas';
    import { Resultado } from '@/__env/lib/Cursos/Resultado';
import { match } from 'assert';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            opcion
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador(): ControladorDeCurso { return Model; }
        public get Curso(): Curso { return this.Controlador.Curso; }

        @Prop()
        public Resultado: Resultado;

        @Prop()
        public Pregunta: Pregunta;
        @Watch( 'Pregunta' , { immediate:true})
        onPregunta( )
        {
            this.Respuesta = this.Resultado.Respuestas.find( x => x.Pregunta == this.Pregunta.Id );
        }
        public Respuesta: Respuesta = null;
        @Prop()
        public Estado: string;


        protected Eventos: Function[] = [];
        beforeDestroy() { this.Eventos.forEach( x => x() ); }
        async mounted()
        {

        }


    }
